<template>
    <v-row dense>
        <v-col cols="12" v-for="(item, index) in fields" :key="item.code">
            <v-row>
                <v-col class="kbDarkBlueText--text"
                       cols="12"
                       sm="6">
                    <span class="collapse">
                        {{item.name}}
                    </span>
                </v-col>
                <v-col cols="12"
                        sm="6"
                        class="collapse grey--text kbDarkBlueText--text text-sm-right">
                    <span v-if="item.type === 'phone'">
                        <img style="margin-top: 5px" class="iti-flag" :class="[item.value.code, 'mr-2']">
                        <span>+{{item.value.number}} {{item.value.phone}}</span>
                    </span>

                    <span v-else class="collapse">
                        {{item.value | formatValue}}
                    </span>
                </v-col>
            </v-row>
            <v-divider v-if="index < fields.length - 1"></v-divider>
        </v-col>

        <v-col cols="12" v-if="files && files.length > 0">
            <v-row class="px-2 py-4"   >
                <v-col cols="12" style="font-size: 20px">
                    {{$t('general.files')}}
                </v-col>

                <v-container class="pa-0 mt-4" fluid>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="4" lg="3" v-for="(file, index) in files" :key="file.newname">
                            <v-card text style="border: 1px solid rgba(0, 0, 0, 0.15)">
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12" class="collapse">
                                            {{file.name}}
                                        </v-col>

                                        <v-col cols="12">
                                            <span class="font-weight-bold kbDarkBlueText--text">Tipo de archivo: </span>
                                            {{file.mimetype}}
                                        </v-col>

                                        <v-col cols="12">
                                            <span class="font-weight-bold kbDarkBlueText--text">Tamaño: </span>
                                            {{file.size | prettySize}}
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn icon
                                           :disabled="downloadingFile"
                                           :loading="downloadingFile && index === indexDownload">
                                        <v-icon color="grey"
                                                @click="downloadFile(index, file.name)">
                                            cloud_download
                                        </v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import formsService from '@/services/formsService'
import pretty from 'prettysize'
export default {
  data () {
    return {
      downloadingFile: false,
      indexDownload: -1
    }
  },
  filters: {
    formatValue: (value) => {
      if (Array.isArray(value)) return value.join(', ')
      return value
    },
    prettySize: (value) => {
      return pretty(value)
    }
  },
  methods: {
    downloadFile (index, filename) {
      this.downloadingFile = true
      this.indexDownload = index
      formsService.downloadFile(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        {
          submitId: this.submitId,
          indexFile: index,
          filename
        }
      ).then(() => {
        this.downloadingFile = false
      }).catch(() => {
        this.downloadingFile = false
      })
    }
  },
  props: ['fields', 'files', 'submitId']
}
</script>

<style>
    .collapse {
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
